import React from 'react';
import {
  Button as AriaButton,
  Label,
  ListBox,
  ListBoxItem,
  Popover,
  Select as AriaSelect,
  SelectValue,
  Key,
  SelectProps
} from 'react-aria-components';

interface AriaSelectDropdownProps extends SelectProps<any> {
  onChangeDropdown(arg: any): void;
  selectedOption: string;
  options: Array<[key: string, value: string]>;
  variant?: string;
  commonClassNamePrefix?: string;
  floatingLabel?: Array<string>
}

function AriaSelectDropdown({
  onChangeDropdown,
  selectedOption,
  options,
  variant,
  commonClassNamePrefix,
  floatingLabel,
  ...props
}: AriaSelectDropdownProps) {
  return (
    <AriaSelect
      onSelectionChange={onChangeDropdown}
      selectedKey={selectedOption}
      {...props}
    >
      <AriaButton className={`react-aria-Button ${`${commonClassNamePrefix}-button`}`}>
        <SelectValue />
        {variant === 'light' ? (
          <img src="/images/ui/down-arrow.svg" />
        ) : (
          <img src="/images/ui/white-down-arrow.svg" />
        )}
      </AriaButton>
      <Popover className={commonClassNamePrefix ? `${commonClassNamePrefix}-popover` : ""}>
        <ListBox>
          {options.map(([key, value], index) => (
            <ListBoxItem id={key} key={index}>
              {floatingLabel && floatingLabel[index] ? <div className="select-floating-label-wrapper"><div className="select-floating-label">{ floatingLabel[index] }</div></div> : <></>}
              {value}
            </ListBoxItem>
          ))}
        </ListBox>
      </Popover>
    </AriaSelect>
  );
}

export default AriaSelectDropdown;
